webpackJsonp([37],{

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(769),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.04b8d3c.png";

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    token: {
      type: String
    },
    type: {
      type: String
    }
  },
  data: function data() {
    return {
      loadingLogo: true
    };
  },

  computed: {
    logoProviderConfirmation: function logoProviderConfirmation() {
      return this.$store.getters.logoProviderConfirmation;
    },
    defaultText: function defaultText() {
      return 'O e-mail de notificação foi enviado pelo ' + this.type;
    }
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;

    var data = {
      token: this.token,
      type: this.type
    };
    this.$store.dispatch('getAllInfoConfirmation', data).then(function (response) {
      _this.loadingLogo = false;
    }).catch(function (err) {
      return console.log(err);
    });
  }
});

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".box-email{background:#fff;width:320px;margin:auto;padding:20px;margin-top:20px;border-radius:20px}.call-cupom{color:#464444;padding:10px;font-size:20px}.cupom{border:1px dashed gray;border-radius:5px;margin:20px}.cupom input{font-size:22px;width:100%;text-align:center;padding:0 15px;color:#464444;text-transform:uppercase}.texto{color:#42964d!important}.logo-header{position:relative;width:100%;text-align:center;padding:20px;min-height:145.63px;background-color:#fff}.administrator,.logo-header img{max-width:200px;max-height:100px}.titulo-logo{width:300px;margin:auto}.titulo-logo h4{width:calc(100% - 80px);color:#a2a2a2;float:left;position:relative;top:11px;font-size:39px;left:2px}.titulo-logo img{width:80px;height:80px;float:left}.progrees-line{position:absolute;bottom:0;margin:0;left:0}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/alreadySent/alreadySent.vue"],"names":[],"mappings":"AACA,WACE,gBAAiB,AACjB,YAAa,AACb,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAoB,CACrB,AACD,YACE,cAAe,AACf,aAAc,AACd,cAAgB,CACjB,AACD,OACE,uBAAwB,AACxB,kBAAmB,AACnB,WAAa,CACd,AACD,aACE,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,eAAkB,AAClB,cAAe,AACf,wBAA0B,CAC3B,AACD,OACC,uBAA0B,CAC1B,AACD,aACI,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,aAAc,AACd,oBAAqB,AACrB,qBAAuB,CAC1B,AACD,gCACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,aACE,YAAa,AACb,WAAa,CACd,AACD,gBACE,wBAAyB,AACzB,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,eAAgB,AAChB,QAAU,CACX,AACD,iBACE,WAAY,AACZ,YAAa,AACb,UAAY,CACb,AACD,eACE,kBAAmB,AACnB,SAAS,AACT,SAAU,AACV,MAAQ,CACT","file":"alreadySent.vue","sourcesContent":["\n.box-email{\n  background: #fff;\n  width: 320px;\n  margin: auto;\n  padding: 20px;\n  margin-top: 20px;\n  border-radius: 20px;\n}\n.call-cupom {\n  color: #464444;\n  padding: 10px;\n  font-size: 20px;\n}\n.cupom{\n  border: 1px dashed gray;\n  border-radius: 5px;\n  margin: 20px;\n}\n.cupom input{\n  font-size: 22px;\n  width: 100%;\n  text-align: center;\n  padding: 0px 15px;\n  color: #464444;\n  text-transform: uppercase;\n}\n.texto{\n\tcolor: #42964d !important;\n}\n.logo-header{\n    position: relative;\n    width: 100%;\n    text-align: center;\n    padding: 20px;\n    min-height: 145.63px;\n    background-color: #fff;\n}\n.logo-header img, .administrator{\n  max-width: 200px;\n  max-height: 100px;\n}\n.titulo-logo{\n  width: 300px;\n  margin: auto;\n}\n.titulo-logo h4 {\n  width: calc(100% - 80px);\n  color: #a2a2a2;\n  float: left;\n  position: relative;\n  top: 11px;\n  font-size: 39px;\n  left: 2px;\n}\n.titulo-logo img {\n  width: 80px;\n  height: 80px;\n  float: left;\n}\n.progrees-line{\n  position: absolute;\n  bottom:0;\n  margin: 0;\n  left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(637);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("39f15c7d", content, true, {});

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#f3f3f3",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "logo-header"
  }, [(_vm.logoProviderConfirmation === '') ? _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "titulo-logo mb-4 float-l"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingLogo),
      expression: "!loadingLogo"
    }],
    attrs: {
      "src": __webpack_require__(404),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingLogo),
      expression: "!loadingLogo"
    }]
  }, [_vm._v("CondoPlaza")])])]) : _c('v-slide-x-transition', {
    staticClass: "hotsite-body",
    attrs: {
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.logoProviderConfirmation,
    attrs: {
      "src": _vm.logoProviderConfirmation,
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingLogo),
      expression: "loadingLogo"
    }],
    staticClass: "progrees-line",
    attrs: {
      "indeterminate": true,
      "height": "2",
      "color": "red",
      "background-color": "white"
    }
  })], 1), _vm._v(" "), (!_vm.loadingLogo) ? _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "box-email"
  }, [_c('div', {
    staticClass: "text-xs-center call-cupom"
  }, [_c('strong', [_vm._v(_vm._s(_vm.defaultText))])])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/37.6027785fae4488ac0123.js